import React, { useState } from 'react';

interface MarqueeHoverProps {
  children: React.ReactNode;
  direction?: 'left' | 'right';
  speed?: number; // animation duration in seconds
  className?: string;
}

const MarqueeHover: React.FC<MarqueeHoverProps> = ({
  children,
  direction = 'left',
  speed = 10,
  className = '',
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const animationDirection =
    direction === 'left' ? 'scroll-left' : 'scroll-right';

  return (
    <div
      className={`overflow-hidden whitespace-nowrap ${className}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div
        className={`inline-block transition-transform duration-300 ${
          isHovered ? 'animate-marquee' : ''
        }`}
        style={{
          animation: isHovered
            ? `${animationDirection} ${speed}s linear infinite`
            : 'none',
        }}
      >
        {children}
      </div>

      <style>{`
        @keyframes scroll-left {
          0% {
            transform: translateX(100%);
          }
          100% {
            transform: translateX(-100%);
          }
        }

        @keyframes scroll-right {
          0% {
            transform: translateX(-100%);
          }
          100% {
            transform: translateX(100%);
          }
        }
      `}</style>
    </div>
  );
};

export default MarqueeHover;
